import React from 'react';

// Mini rendu Markdown (sans dépendance externe).
// Supporte : ## titres, ### sous-titres, listes -/*, gras **texte**, italique *texte*, retours à la ligne.
function inline(text) {
  const parts = [];
  let rest = String(text);
  let i = 0;
  const patterns = [
    { re: /\*\*(.+?)\*\*/, tag: 'strong' },
    { re: /\*(.+?)\*/, tag: 'em' },
    { re: /`([^`]+)`/, tag: 'code' },
  ];
  while (rest.length) {
    let matched = null;
    for (const p of patterns) {
      const m = rest.match(p.re);
      if (m && (matched === null || m.index < matched.index)) matched = { ...m, tag: p.tag };
    }
    if (!matched) { parts.push(<span key={i++}>{rest}</span>); break; }
    if (matched.index > 0) parts.push(<span key={i++}>{rest.slice(0, matched.index)}</span>);
    const inner = matched[1];
    if (matched.tag === 'strong') parts.push(<strong key={i++} className="font-semibold text-[#1A2421]">{inner}</strong>);
    else if (matched.tag === 'em') parts.push(<em key={i++}>{inner}</em>);
    else parts.push(<code key={i++} className="bg-[#F5F4EF] px-1 py-0.5 rounded text-[0.85em]">{inner}</code>);
    rest = rest.slice(matched.index + matched[0].length);
  }
  return parts;
}

export function MarkdownPreview({ text, className = '', testId }) {
  const src = String(text || '');
  const lines = src.split('\n');
  const out = [];
  let list = null;
  let key = 0;

  const flush = () => {
    if (list) { out.push(<ul key={key++} className="list-disc pl-5 space-y-0.5 text-[#1A2421]">{list}</ul>); list = null; }
  };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); continue; }
    if (/^###\s+/.test(line)) { flush(); out.push(<h4 key={key++} className="text-sm font-semibold text-[#1A2421] mt-2">{inline(line.replace(/^###\s+/, ''))}</h4>); continue; }
    if (/^##\s+/.test(line))  { flush(); out.push(<h3 key={key++} className="text-base font-bold text-[#2D5A4C] mt-3" style={{ fontFamily: 'Manrope' }}>{inline(line.replace(/^##\s+/, ''))}</h3>); continue; }
    if (/^[-*]\s+/.test(line)) { if (!list) list = []; list.push(<li key={key++}>{inline(line.replace(/^[-*]\s+/, ''))}</li>); continue; }
    if (/^\d+\.\s+/.test(line)) { flush(); out.push(<p key={key++} className="text-[#1A2421] leading-relaxed"><span className="font-semibold text-[#2D5A4C] mr-1">{line.match(/^(\d+)\./)[1]}.</span>{inline(line.replace(/^\d+\.\s+/, ''))}</p>); continue; }
    flush();
    out.push(<p key={key++} className="text-[#1A2421] leading-relaxed">{inline(line)}</p>);
  }
  flush();

  return <div className={`max-w-none space-y-1 ${className}`} data-testid={testId}>{out}</div>;
}
